import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage1 from '../assets/images/intro/bg1.png'
import backgroundImage2 from '../assets/images/intro/bg2.png'
import continueBtnImage from '../assets/images/intro/continue.png';

class Intro extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            index: 0
        };
    }
    
    continueBtnClick() {
        this.playBtnSound();
        if (this.state.index === 0) {
            this.setState({
                index: 1
            });
        } else {
            this.props.history.push({
                pathname: './stage1-intro'
            });
        }
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={this.state.index === 0 ? backgroundImage1 : backgroundImage2} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img className='press-btn' alt='' src={continueBtnImage} style={{ height: '12%', bottom: '4%', left: '38.5%', position: 'absolute', background: 'transparent' }} onClick={this.continueBtnClick.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Intro);
